import {ReactNode} from 'react';
import {Navigate} from 'react-router';
import {useParams} from 'react-router-dom';
import {useEnvironmentStore} from '@di-shared/features/environment/environmentStore';
import {ROUTE_PATHS} from '@di-shared/routes';

export interface VinGuardProps {
  children(vin: string): ReactNode;
}

function VinGuard({children}: VinGuardProps): JSX.Element {
  const params = useParams();
  const setVin = useEnvironmentStore((state) => state.setVin);

  if (!params.vin) {
    return (
      <Navigate
        to={ROUTE_PATHS.ERROR.getFullPath()}
        replace
      />
    );
  }
  setVin(params.vin);

  return <>{children(params.vin)}</>;
}

export default VinGuard;
